module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sl-mini-sidebar"
  }, [_c('div', {
    staticClass: "sl-username"
  }, [_c('span', [_vm._v(_vm._s(_vm.$store.state.user.userinfo.merchantName))]), _vm._v(" "), _c('div', {
    staticClass: "sl-menu-close-icon",
    on: {
      "click": _vm.hideMenu
    }
  })]), _vm._v(" "), _c('el-menu', {
    attrs: {
      "default-active": _vm.currentPage,
      "unique-opened": true,
      "router": true
    },
    on: {
      "select": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_vm._l((_vm.slider), function(item, index) {
    return [(item.menu === '/coupons') ? _c('div', {
      staticClass: "sl-sidebar-border"
    }) : _vm._e(), _vm._v(" "), (item.children.length === 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.url
      }
    }, [_c('div', {
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "display": "inline-block"
      }
    }, [_c('i', {
      class: item.icon,
      staticStyle: {
        "margin-right": "5px"
      }
    }), _vm._v(_vm._s(item.name) + "\n        ")])]) : _vm._e(), _vm._v(" "), (item.menu === '/dashboard') ? _c('div', {
      staticClass: "sl-sidebar-border"
    }) : _vm._e(), _vm._v(" "), (item.menu === '/coupons') ? _c('div', {
      staticClass: "sl-sidebar-border"
    }) : _vm._e(), _vm._v(" "), (item.children.length !== 0) ? _c('el-submenu', {
      attrs: {
        "index": index.toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "display": "inline-block"
      }
    }, [_c('i', {
      class: item.icon,
      staticStyle: {
        "margin-right": "5px"
      }
    }), _vm._v(_vm._s(item.name) + "\n          ")])]), _vm._v(" "), _vm._l((item.children), function(it, i) {
      return _c('el-menu-item', {
        attrs: {
          "index": it.url
        }
      }, [_c('div', {
        staticStyle: {
          "height": "20px",
          "line-height": "20px",
          "display": "inline-block"
        }
      }, [_c('i', {
        staticClass: "fa fa-crosshairs",
        staticStyle: {
          "margin-right": "5px"
        }
      }), _vm._v(_vm._s(it.name) + "\n          ")])])
    })], 2) : _vm._e()]
  })], 2), _vm._v(" "), (!_vm.$store.state.userAgent.isPhone) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "sl-sidebar-app"
  }, [_c('img', {
    staticClass: "sidebar-logo",
    attrs: {
      "src": ("/static/" + (this.$store.state.theme.name) + "/sidebar-logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name-app"
  }, [_vm._v(_vm._s(_vm.$t('Navigator.appName')))]), _vm._v(" "), _c('img', {
    staticClass: "qrcode-app",
    attrs: {
      "src": require("./assets/imgs/qrcode.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "category-app"
  }, [_vm._v("iOS & Android")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7c2f584!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Slider-mini.vue
// module id = 1123
// module chunks = 1